import { BaseSpine } from '../core/pixi/pixiBaseSpine';
import { pixiResourceHelper } from '../helpers/pixiResourceHelper';

export class Spine extends BaseSpine {
  constructor(options) {
    const { spineData } = pixiResourceHelper.get(options.key);
    super(spineData);
    this.animationPromises = new Map();

    this.key = options.key;
    this._listeners = [];
    // construct().call(this, options);
    this.roundPixels = false;
    this.show = () => {
      // in construct.call we create _hide method so we need to override it here
      this.visible = true;
      this.lastTime = 0; // we do this in order next time we start scaleAnimation its delta time on update is calculated from now not from when last visible (so onComplete not be called at once because of big time delta)
    };
    if (options.animation) {
      this.play(options.animation.name, options.animation.loop, options.animation.timeScale);
    }
  }

  // applyStyles(styles = {}) {
  //   // if (Array.isArray(styles)) styles = styles.reduce((r, c) => Object.assign(r, c), {});
  //   // for (const prop in styles) {
  //   //   const value = styles[prop];
  //   //   if (commonPropertySetters[prop]) commonPropertySetters[prop].call(this, value);
  //   // }
  //
  //   if (Array.isArray(styles)) styles = styles.reduce((r, c) => Object.assign(r, c), {});
  //   // eslint-disable-next-line no-restricted-syntax, guard-for-in
  //   for (const prop in styles) {
  //     const value = styles[prop];
  //     if (commonPropertySetters[prop]) commonPropertySetters[prop].call(this, value);
  //     else if (prop === 'tint') this.setTint(value);
  //     else if (prop === 'animation') this.play(value.name, value.loop, value.timeScale);
  //   }
  // }

  play(animationName, loop = false, timeScale = 1, trackPlace = 0, reverse = false) {
    // if(this.elementId === 'bonusBg'){
    //     console.warn('play', animationName, loop, timeScale, trackPlace, reverse)
    // }
    this.clearAnimationData(trackPlace);
    this.lastTime = 0;
    // if(this.isPlaying())this._stop();
    if (this.state.hasAnimation(animationName)) {
      this.state.setAnimation(trackPlace, animationName, loop);
      this.state.tracks[trackPlace].timeScale = timeScale;
      if (reverse) this.reverseCurrentAnimation(this.state.tracks[trackPlace]);
    }
  }

  playAndWait(
    animationName,
    event = 'complete',
    forceResolve = false,
    timeScale = 1,
    trackPlace = 0,
    reverse = false,
    alpha = 1
  ) {
    // if(this.elementId === 'bonusBg'){
    //     console.warn('playAndWait', animationName, timeScale, trackPlace, reverse)
    // }
    // const start = performance.now();
    this.clearAnimationData(trackPlace);
    return new Promise((r) => {
      this.play(animationName, false, timeScale, trackPlace, reverse);
      if (this.state.tracks[trackPlace]) this.state.tracks[trackPlace].alpha = alpha;
      if (this.getCurrentAnimationName(trackPlace) === animationName) {
        const o = (trackEntry) => {
          if (reverse && trackEntry.animationLast < trackEntry.trackTime) return;
          this.animationPromises.delete(trackPlace);
          r();
        };
        this.addListener(event, o, null, true, animationName);
        this.animationPromises.set(trackPlace, {
          forceResolve,
          resolver: r,
          animationName,
          event,
          listener: o,
        });
      } else r();
    });
  }

  clearAnimationData(trackPlace) {
    if (this.animationPromises.has(trackPlace)) {
      const data = this.animationPromises.get(trackPlace);
      if (data.forceResolve) data.resolver();
      this.removeListener(data.event, data.listener, null, data.animationName);
      this.animationPromises.delete(trackPlace);
    }
  }

  reverseCurrentAnimation(track, trackPlace, name) {
    if (!track) {
      if (trackPlace !== undefined) track = this.state.tracks[trackPlace];
      else track = this.state.tracks.find((a) => a.animation.name === name);
    }
    if (track) {
      if (
        track.timeScale > 0 &&
        (track.trackTime > track.animationEnd || track.trackTime === track.animationStart)
      )
        track.trackTime = track.animationEnd;
      else if (track.timeScale < 0 && track.trackTime < track.animationStart)
        track.trackTime = track.animationStart;
      track.timeScale *= -1;
    }
  }

  accelerateCurrentAnimation(factor) {
    const animation = this.state.tracks[0];
    if (animation) {
      animation.timeScale *= factor;
    }
  }

  stop({ trackPlace, animationName } = {}) {
    if (trackPlace === undefined && animationName)
      trackPlace = this.state.tracks.findIndex((t) => t && t.animation.name === animationName);
    if (trackPlace >= 0) {
      // if(this.elementId === 'bonusBg'){
      //     console.warn('stop trackPlace', trackPlace, animationName);
      // }
      this.clearTrack(trackPlace);
      if (this.animationPromises.has(trackPlace)) {
        const data = this.animationPromises.get(trackPlace);
        if (data.forceResolve) data.resolver();
        this.animationPromises.delete(trackPlace);
      }
    } else {
      // if(this.elementId === 'bonusBg'){
      //     console.warn('stop else', trackPlace, animationName);
      // }
      this.state.clearTracks();
      this.skeleton.setToSetupPose();
      this.animationPromises.forEach((data) => {
        if (data.forceResolve) data.resolver();
      });
      this.animationPromises.clear();
    }
  }

  clearTrack(index) {
    this.state.clearTrack(index);
    // if(typeof index ==='number')this.state.tracks.splice(index,1);//pixi-spine place null in the index
  }

  stopAnimation(name) {
    const index = this.state.tracks.findIndex((t) => t && t.animation.name === name);

    if (index > -1) {
      this.state.clearTrack(index);
      this.state.tracks.splice(index, 1); // pixi-spine place null in the index
    }
  }

  getCurrentAnimationsData() {
    return this.state.tracks.reduce((r, c, i) => {
      if (c) {
        r.push({
          name: c.animation.name,
          loop: c.loop,
          trackPlace: i,
          timeScale: c.timeScale,
        });
      }
      return r;
    }, []);
  }

  getCurrentAnimationName(trackPlace = 0) {
    return this.state.tracks[trackPlace] ? this.state.tracks[trackPlace].animation.name : '';
  }

  getCurrentAnimationLoop() {
    return this.state.tracks[0] ? this.state.tracks[0].loop : false;
  }

  addOnCompleteHandler(handler, context = null, once = false) {
    const listener = {};
    // we need delayWrapper because current pixi-spine events complete is fired between updateTransform and render.
    // We encountered problem when on some spine scaleAnimation complete event we make other spine(with mask somewhere) visible. Here displayObject.render called before updateTransform for our mask, and
    // that cause mask.geometry.points array stay empty (points are copied from graphiksdata.shape.points only ones when first rendered) because graphiksdata.shape.points are calculated on updateTransform
    function delayWrapper(...args) {
      requestAnimationFrame(() => {
        handler.call(context, ...args);
      });
    }
    let h = delayWrapper;
    if (once) {
      h = () => {
        delayWrapper();
        this.state.removeListener(listener);
      };
    }
    listener.complete = h;
    this.state.addListener(listener);
    return listener;
  }

  removeOnCompleteHandler(listener) {
    this.state.removeListener(listener);
  }

  isPlaying() {
    const animation = this.state.tracks[0];
    return !!(
      animation &&
      ((animation.timeScale > 0 && animation.getAnimationTime() < animation.animationEnd) ||
        (animation.timeScale < 0 && animation.getAnimationTime() > 0))
    );
  }

  changeTexture(key) {
    if (this.key === key) return;
    this.key = key;
    this.removeChildren();
    const { spineData } = pixiResourceHelper.get(key);
    this.spineData = spineData;
    this.skeleton = new spineCore.Skeleton(spineData);
    this.skeleton.updateWorldTransform();
    this.stateData = new spineCore.AnimationStateData(spineData);
    this.state = new spineCore.AnimationState(this.stateData);
    this.slotContainers = [];
    this.tempClipContainers = [];
    for (let i = 0, n = this.skeleton.slots.length; i < n; i += 1) {
      const slot = this.skeleton.slots[i];
      const { attachment } = slot;
      const slotContainer = this.newContainer();
      this.slotContainers.push(slotContainer);
      this.addChild(slotContainer);
      this.tempClipContainers.push(null);
      if (attachment instanceof spineCore.RegionAttachment) {
        const spriteName = attachment.region.name;
        const sprite = this.createSprite(slot, attachment, spriteName);
        slot.currentSprite = sprite;
        slot.currentSpriteName = spriteName;
        slotContainer.addChild(sprite);
      } else if (attachment instanceof spineCore.MeshAttachment) {
        const mesh = this.createMesh(slot, attachment);
        slot.currentMesh = mesh;
        slot.currentMeshName = attachment.name;
        slotContainer.addChild(mesh);
      } else if (attachment instanceof spineCore.ClippingAttachment) {
        this.createGraphics(slot, attachment);
        slotContainer.addChild(slot.clippingContainer);
        slotContainer.addChild(slot.currentGraphics);
      }
    }
  }

  setSmoothTransition(animationNames, duration) {
    // duration in seconds
    if (animationNames.length < 2 || duration === 0) return;
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const fromIndex in animationNames) {
      // eslint-disable-next-line no-restricted-syntax
      for (const toIndex in animationNames) {
        if (toIndex !== fromIndex)
          this.stateData.setMix(animationNames[fromIndex], animationNames[toIndex], duration);
      }
    }
  }

  getAnimationDuration(animationName) {
    const animationData = this.spineData.animations.find((a) => a.name === animationName);
    return animationData ? animationData.duration : 0;
  }

  getTrackByAnimationName(animationName) {
    return animationName
      ? this.state.tracks.find((a) => a && a.animation.name === animationName)
      : null;
  }

  addListener(event, listener, context, animationName, once = false) {
    const isStandardEvent =
      ['start', 'complete', 'end', 'dispose', 'interrupted'].indexOf(event) > -1;
    const onceListener = once
      ? (...args) => {
          this.removeListener(event, listener, context, animationName);
          listener.call(context, ...args);
        }
      : listener;
    const f = isStandardEvent
      ? onceListener.bind(context)
      : (track, evt) => {
          if (evt.data.name === event) {
            onceListener.call(context, track, evt);
          }
        };
    const eventKey = isStandardEvent ? event : 'event';
    const l = {
      [eventKey]: f,
    };
    const track = this.getTrackByAnimationName(animationName);
    if (track) {
      if (track.listener) {
        track.listener[eventKey] = f;
      } else track.listener = l;
    } else this.state.addListener(l); // listener will be called for every scaleAnimation in tracks list
    this._listeners.push({ l, listener, context });
    return this.removeListener.bind(this, event, listener, context, animationName);
  }

  removeListener(event, listener, context, animationName) {
    const i = this._listeners.findIndex((a) => a.listener === listener && a.context === context);
    if (i > -1) {
      const data = this._listeners.splice(i, 1)[0];
      if (animationName) {
        const track = this.getTrackByAnimationName(animationName);
        if (track && track.listener) {
          delete track.listener[event];
          if (Object.keys(track.listener).length === 0) track.listener = null;
        }
      }
      this.state.removeListener(data.l);
    }
  }

  clearListeners() {
    this._listeners.length = 0;
    this.state.clearListeners();
    this.state.tracks.forEach((t) => {
      if (t) t.listener = null;
    });
  }

  callAllListenersAndStop() {
    this._listeners.forEach((a) => a.listener.call(a.context));
    this.stop();
    this.clearListeners();
  }

  addChildToSlot(slotName, child, index = 0) {
    const p = this.getSlot(slotName);
    if (p) {
      (p.children[index] || p).addChild(child);
      return true;
    }
    return false;
  }

  removeChildFromSlot(slotName, child, index = 0) {
    const p = this.getSlot(slotName);
    if (p) {
      (p.children[index] || p).removeChild(child);
      return true;
    }
    return false;
  }

  getSlot(slotName) {
    const index = this.spineData.slots.findIndex((slotData) => slotData.name === slotName);
    return this.children[index];
  }

  getBlankImageOfSlot(slotName) {
    const slot = this.getSlot(slotName);
    return slot ? (slot.children[0] ? slot.children[0] : slot) : null;
  }

  goToAnimationEnd(name) {
    const track = this.getTrackByAnimationName(name);
    if (track) {
      track.trackTime = track.animationEnd;
    }
  }

  // setToEnd(animationName, trackPlace) {
  //   if (this.state.hasAnimation(animationName)) {
  //     this.state.setAnimation(trackPlace, animationName, false);
  //     this.state.tracks[trackPlace].timeScale = timeScale;
  //   }
  // }

  addReversedAnimation(sourceName, newName) {
    const { animations } = this.state.data.skeletonData;
    const animationData = animations.find((a) => a.name === sourceName);
    if (animationData) {
      const reversedTimeLine = [...animationData.timelines];
      reversedTimeLine.reverse();
      animations.push(new spineCore.Animation(newName, reversedTimeLine, animationData.duration));
    }
  }
}
